import React from 'react'
import { Box } from '@mui/material'

/**
 * Drop-in for `react-spinners` PacmanLoader.
 */
export function PacmanLoader({
  color = '#ffffff',
  loading = true,
  size = 25,
  margin = 2,
  speedMultiplier = 1,
  cssOverride = {},
  style,
  ...rest
}) {
  if (!loading) return null

  const s = Math.max(8, Number(size) || 25)
  const m = Number(margin) || 2
  const ball = s / 3
  const speed = Math.max(0.1, Number(speedMultiplier) || 1)
  const duration = `${0.8 / speed}s`
  const width = s * 2 + ball * 3 + m * 6

  return (
    <Box
      component="span"
      role="status"
      aria-label="loading"
      data-hf="pacman"
      sx={{
        display: 'inline-block',
        position: 'relative',
        fontSize: 0,
        boxSizing: 'border-box',
        height: s,
        width,
        pl: `${s + m}px`,
        '@keyframes hfPacmanNibbleTop': {
          '0%, 100%': { transform: 'rotate(0deg)' },
          '50%': { transform: 'rotate(-44deg)' },
        },
        '@keyframes hfPacmanNibbleBottom': {
          '0%, 100%': { transform: 'rotate(0deg)' },
          '50%': { transform: 'rotate(44deg)' },
        },
        '@keyframes hfPacmanBall': {
          '75%, 100%': { opacity: 0.15, transform: 'translateX(-200%)' },
        },
        ...cssOverride,
        ...style,
      }}
      {...rest}
    >
      <Box
        component="span"
        data-hf="pacman-mouth"
        sx={{
          position: 'absolute',
          left: 0,
          top: 0,
          width: s,
          height: s,
          borderRadius: '100%',
          boxSizing: 'border-box',
          background: color,
          clipPath: 'polygon(0 0, 100% 0, 100% 50%, 0 50%)',
          animation: `hfPacmanNibbleTop ${duration} infinite`,
          transformOrigin: 'center center',
        }}
      />
      <Box
        component="span"
        data-hf="pacman-mouth"
        sx={{
          position: 'absolute',
          left: 0,
          top: 0,
          width: s,
          height: s,
          borderRadius: '100%',
          boxSizing: 'border-box',
          background: color,
          clipPath: 'polygon(0 50%, 100% 50%, 100% 100%, 0 100%)',
          animation: `hfPacmanNibbleBottom ${duration} infinite`,
          transformOrigin: 'center center',
        }}
      />
      {[0, 1, 2, 3].map((i) => (
        <Box
          component="span"
          key={i}
          sx={{
            display: 'inline-block',
            width: ball,
            height: ball,
            borderRadius: '100%',
            background: color,
            margin: `${(s - ball) / 2}px ${m}px`,
            animation: `hfPacmanBall ${duration} infinite linear`,
            animationDelay: `${(-i * 0.2) / speed}s`,
          }}
        />
      ))}
    </Box>
  )
}

export default PacmanLoader
